import React, { useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";

function Headers() {
  const [hoverMenu, setHoverMenu] = useState(null);
  const [pinnedMenu, setPinnedMenu] = useState(null);
  const navigator = useNavigate();

  const activeMenu = pinnedMenu ?? hoverMenu;

  return (
    <div className="header me">
      <div className="h1head">

        {/* ACADEMY – now contains BOTH items */}
        <div
          className="dropdownWrapper"
          onMouseEnter={() => setHoverMenu("academy")}
          onMouseLeave={() => setHoverMenu(null)}
        >
          <button
            type="button"
            className="dropdownToggle"
            aria-expanded={activeMenu === "academy"}
            onClick={(e) => {
              e.stopPropagation();
              setPinnedMenu(prev => (prev === "academy" ? null : "academy"));
            }}
          >
            MoM śālā
          </button>

          <div
            className={`dropdownMenu ${activeMenu === "academy" ? "show" : ""}`}
            style={
              {
              overflow:"hidden",
              maxHeight: activeMenu === "academy" ? "320px" : "0px",
              transition:"max-height .28s ease, opacity .2s ease",
              opacity: activeMenu === "academy" ? 1 : 0
            }}
          >
           <Link to="/classroom" className="dropItem lectures">Lectures</Link>
<Link to="/workshops" className="dropItem workshops">Workshops</Link>

          </div>
        </div>

        {/* Projects & Publication remain */}
        <Link to="/projects">MoM Projects</Link>
        <Link to="/publication">MoM Publication</Link>
        <Link to="/videoGallery" className="dropdownToggle">
          MoM Gallery
        </Link>

        {/* SHOP replaced with a normal link */}
        <Link to="/shop" className="dropdownToggle">
          MoM Shop
        </Link>

      </div>

      {/* Logo */}
      <div className="h2head" onClick={() => navigator("/")}>
        m(o)m
      </div>
    </div>
  );
}

export default Headers;
